var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "board"
  }, [_c('img', {
    staticClass: "board-img zoom",
    class: {
      show: _vm.isShow(2)
    },
    attrs: {
      "src": require("../assets/ttop.png"),
      "data-magnify-src": "/static/ttop.png",
      "alt": "ttop"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "board-img _bottom",
    class: {
      show: _vm.isShow(2)
    },
    attrs: {
      "src": require("../assets/tbase.png"),
      "alt": "tbase"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "board-img zoom",
    class: {
      show: _vm.isShow(3)
    },
    attrs: {
      "src": require("../assets/ftop.png"),
      "data-magnify-src": "/static/ftop.png",
      "alt": "ftop"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "board-img _bottom",
    class: {
      show: _vm.isShow(3)
    },
    attrs: {
      "src": _vm.fSrc,
      "alt": "fbase"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "toggle __f",
    class: {
      show: _vm.isShow(3), fSec: _vm.changeColor(3)
    },
    on: {
      "click": function($event) {
        _vm.toggle(3)
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "board-img zoom",
    class: {
      show: _vm.isShow(4)
    },
    attrs: {
      "src": require("../assets/utop.png"),
      "data-magnify-src": "/static/utop.png",
      "alt": "utop"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "board-img _bottom",
    class: {
      show: _vm.isShow(4)
    },
    attrs: {
      "src": _vm.uSrc,
      "alt": "ubase"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "toggle __u",
    class: {
      show: _vm.isShow(4), uSec: _vm.changeColor(4)
    },
    on: {
      "click": function($event) {
        _vm.toggle(4)
      }
    }
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-059e6d32","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/board.vue
// module id = hDGN
// module chunks = 0